import { Text } from '@/components/common'
import { Campaign } from '@/services/api/campaign'
import { formatMoney } from '@/utils'

interface Props {
  campaign: Campaign
  className?: string
}

const PriorRaise = ({ campaign, className }: Props) => {
  const priorRaises = campaign.priorRaiseTotal

  if (priorRaises.amount === 0) return null

  return (
    <div className={className}>
      <div className="flex items-center justify-between">
        <Text
          as="div"
          preset="heading.eyebrow"
          className="flex-1 uppercase leading-none"
        >
          Previous Rounds:
        </Text>

        <div className="ml-8 flex-grow-0">
          <Text as="div" preset="body.md">
            {formatMoney(priorRaises.amount, {
              zeroFractionDigits: true,
            })}
          </Text>
          <Text as="div" preset="body.xs" className="uppercase">
            Raised
          </Text>
        </div>

        <div className="ml-8 flex-[0_3.75rem]">
          <Text as="div" preset="body.md">
            {priorRaises.backers.toLocaleString()}
          </Text>
          <Text as="div" preset="body.xs" className="uppercase">
            Backers
          </Text>
        </div>
      </div>
    </div>
  )
}

export default PriorRaise
